module.exports = __webpack_public_path__ + "img/loans-rejected.42fc74f2.svg";